<script>
export default {
    name: 'BackbeatDashboard',
    props: {},
};
</script>

<template>
    <div class="backbeat-dashboard">
        <div class="dashboard-header">
            <slot name="dashboard-header" />
        </div>
        <div class="dashboard-content">
            <slot name="dashboard-content" />
        </div>
        <div class="dashboard-footer">
            <slot name="dashboard-footer" />
        </div>
    </div>
</template>

<style scoped>
.backbeat-dashboard {
    width: 100%;
}
</style>
